import List from 'list.js';
jQuery(function () {
  var options = {
    valueNames: ['job', 'company', 'location']
  };
  var userList = new List('job-table', options);
  var searchText = jQuery('input.search').val();
  userList.search(searchText);
});